import styles from './Contest.module.css';
export const Contest = () => {
	return (
		<section className={styles['contest']}>
			<iframe title="Contest" src="https://www.pw.org/grants" />
		</section>
	);
};
